import { noop } from 'lodash';

import React, { ComponentProps, PropsWithChildren } from 'react';

import { Button as ButtonDS, Spinner } from '@zapier/design-system';

type ButtonDSProps = ComponentProps<typeof ButtonDS>;

type Props = {
  href?: ButtonDSProps['href'];
  isDisabled?: ButtonDSProps['disabled'];
  isWorking?: boolean;
  onClick?: ButtonDSProps['onClick'];
  target?: ButtonDSProps['target'];
};

const defaultProps = {
  href: undefined,
  isDisabled: false,
  isWorking: false,
  onClick: noop,
  target: undefined,
};

function Button(props: PropsWithChildren<Props>) {
  const {
    href = defaultProps.href,
    isDisabled = defaultProps.isDisabled,
    isWorking = defaultProps.isWorking,
    children,
    onClick = defaultProps.onClick,
    target = defaultProps.target,
  } = props;

  return (
    <ButtonDS
      aria-label="submit"
      disabled={isDisabled}
      hasShadow={!isDisabled}
      href={href}
      onClick={onClick}
      target={target}
    >
      {isWorking ? <Spinner /> : children}
    </ButtonDS>
  );
}

export default Button;
